import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PrimaryWithIconButton from "../../../../_utils/CommonButtons/PrimaryWithIconButton";
import IconTearDropButton from "../../../../_utils/CommonButtons/IconTearDropButton";
import TitleSubtitlePair from "../../../../_utils/TitleSubtitlePair";
import ICONS from "../../../../../assets/Icons";

const RolesTagsContainer = ({
  setLabelpopup = () => {},
  labels = [],
  subText1 = "",
  isOptional = false,
  title = "",
  buttonName = "Add",
  buttonImageUrl = "",
  previewMode = false,
}) => {
  const services = useSelector((state) => state.refreshToken.services);
  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");
  const navigate = useNavigate();
  const isServiceMissing = !(hasALabel && hasRLabel);
  const handleLabelPopup = () => {
    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setLabelpopup(true);
    }
  };

  if (previewMode) {
    return (
      <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
        <div className="text-text-primary font-semibold text-font-md">
          <span className="font-semibold">{title}</span>
          {isOptional && <span className="font-normal"> (Optional)</span>}
        </div>
        <div className="flex flex-col gap-gap-sm">
          <TitleSubtitlePair
            title={
              labels?.length
                ? labels.map((label) => label.value).join(", ")
                : "Not assigned"
            }
            titleColor="text-primary"
            subtitle={title}
            alignRight={false}
            hoverOption="white"
            isBold={false}
            variant="md"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col relative">
      <div className="p-padding-md h-height-full bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="flex justify-between items-start">
            <div className="flex flex-col gap-gap-xs">
              <div className="text-text-primary text-font-md">
                <span className="font-semibold">{title}</span>
                {isOptional && <span className="font-normal"> (Optional)</span>}
              </div>
              <div className="text-text-secondary text-font-xs">{subText1}</div>
            </div>

            {labels?.length > 0 && (
              <div className="top-top-base right-right-base absolute">
                <IconTearDropButton
                  handleFunction={() => handleLabelPopup()}
                  isDisabled={false}
                  isLoading={false}
                  enabledBgColor={"var(--primary-nav-act)"}
                  icon={ICONS?.EDIT}
                  hoverOption="white"
                  title="Edit"
                />
              </div>
            )}
          </div>
          {labels?.length > 0 ? (
            <div>
              <div className="flex flex-wrap gap-gap-button-m   ">
                {labels.map((item, index) => (
                  <div
                    key={index}
                    className="bg-primary-nav text-text-primary px-padding-sm py-padding-xs rounded-full text-font-xs flex items-center gap-gap-xs max-w-full"
                  >
                    <span className="truncate min-w-0">{item?.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <PrimaryWithIconButton
              btnText={buttonName}
              enabledBgColor="var(--primary-nav)"
              isDisabled={false}
              handleFunction={() => {
                setLabelpopup(true);
              }}
              iconToBeAlign="left"
              enabledTextColor={"var(--text-primary)"}
              icon={buttonImageUrl}
              fullWidthRequired={true}
              hoverOption="white"
              imgColor={title === "Roles" ? "var(--text-primary)" : ""}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RolesTagsContainer;
